import { Skeleton } from '@mui/material';
import { ConditionalLoaderProps } from './ConditionalLoader.props';

const ConditionalLoader = ({ isLoading, children, width = 500, height = 40 }: ConditionalLoaderProps) =>
  isLoading ? <Skeleton variant="text" width={width} height={height} /> : children;

export default ConditionalLoader;
